import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@davita/bridge-library/progress-bar';
import { BriProgressBarModule } from '@davita/bridge-library/progress-bar';

class BriQualtricsSurveyComponent {
    zone;
    qualtricsId = '';
    externalReference = '';
    isLoading = true;
    QSI;
    constructor(zone) {
        this.zone = zone;
    }
    ngAfterViewInit() {
        const surveyDiv = document.getElementById(this.qualtricsId);
        if (surveyDiv) {
            // check every 100ms for the QSI object to be available and stop after 10 seconds
            this.waitForQSI(100, 10000).then(() => {
                this.runQSI();
            });
        }
    }
    waitForQSI(interval, timeout) {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            const checkQSI = () => {
                if (window.QSI?.API) {
                    this.QSI = window.QSI;
                    resolve();
                }
                else if (Date.now() - startTime >= timeout) {
                    reject();
                }
                else {
                    setTimeout(checkQSI, interval);
                }
            };
            checkQSI();
        });
    }
    runQSI() {
        if (this.QSI?.API) {
            this.QSI.API.unload();
            this.QSI.config = { externalReference: this.externalReference };
            this.QSI.API.load().then(() => {
                this.zone.run(() => {
                    this.QSI.API.run();
                    this.isLoading = false;
                });
            });
        }
    }
    ngOnDestroy() {
        if (this.QSI?.API) {
            this.QSI.API.unload();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriQualtricsSurveyComponent, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BriQualtricsSurveyComponent, selector: "bri-qualtrics-survey", inputs: { qualtricsId: "qualtricsId", externalReference: "externalReference" }, ngImport: i0, template: "<div class=\"survey\">\n  <bri-progress-bar *ngIf=\"isLoading\"></bri-progress-bar>\n  <div\n    class=\"qualtics-anchor\"\n    [attr.id]=\"qualtricsId\"\n    [style.visibility]=\"isLoading ? 'hidden' : 'visible'\"\n  ></div>\n</div>\n", styles: [".survey{display:flex;justify-content:center;align-items:center;flex-direction:column;height:100%;width:100%;min-height:400px}.survey .qualtics-anchor{width:100%;height:100%;display:flex;flex-direction:column;align-items:center}.survey .qualtics-anchor ::ng-deep .scrollable{-ms-overflow-style:none!important;scrollbar-width:none!important}.survey .qualtics-anchor ::ng-deep .scrollable ::-webkit-scrollbar{display:none!important}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.BriProgressBarComponent, selector: "bri-progress-bar", inputs: ["message", "mode", "percent", "height", "width", "color", "indicator", "isRequiredTitleCase"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriQualtricsSurveyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bri-qualtrics-survey', template: "<div class=\"survey\">\n  <bri-progress-bar *ngIf=\"isLoading\"></bri-progress-bar>\n  <div\n    class=\"qualtics-anchor\"\n    [attr.id]=\"qualtricsId\"\n    [style.visibility]=\"isLoading ? 'hidden' : 'visible'\"\n  ></div>\n</div>\n", styles: [".survey{display:flex;justify-content:center;align-items:center;flex-direction:column;height:100%;width:100%;min-height:400px}.survey .qualtics-anchor{width:100%;height:100%;display:flex;flex-direction:column;align-items:center}.survey .qualtics-anchor ::ng-deep .scrollable{-ms-overflow-style:none!important;scrollbar-width:none!important}.survey .qualtics-anchor ::ng-deep .scrollable ::-webkit-scrollbar{display:none!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }]; }, propDecorators: { qualtricsId: [{
                type: Input
            }], externalReference: [{
                type: Input
            }] } });

class BriQualtricsSurveyModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriQualtricsSurveyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: BriQualtricsSurveyModule, declarations: [BriQualtricsSurveyComponent], imports: [CommonModule, BriProgressBarModule], exports: [BriQualtricsSurveyComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriQualtricsSurveyModule, imports: [CommonModule, BriProgressBarModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BriQualtricsSurveyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BriQualtricsSurveyComponent],
                    imports: [CommonModule, BriProgressBarModule],
                    exports: [BriQualtricsSurveyComponent],
                }]
        }] });

/*
 * Public API Surface of davita-card
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BriQualtricsSurveyComponent, BriQualtricsSurveyModule };
